module.exports = __webpack_public_path__ + "img/bird-3-left.77a2ac68.png";